"use strict";

/* global window, global, document */
module.exports = {
  window: typeof window !== 'undefined' ? window : global,
  global: typeof global !== 'undefined' ? global : window,
  document: typeof document !== 'undefined' ? document : {}
};
//# sourceMappingURL=globals.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/es5/utils/globals.js
// module id = 558
// module chunks = 35783957827783